module.exports = __webpack_public_path__ + "static/media/barcode.2e335f4f.svg";